import { ZoomImageContainer } from "shared/components/Parameters";
import Layout from "../../components/mainPage/Layout";
import MQTTClient from "../../images/systemComponents/MQTTClient.svg";
export const Page = () => {
    return <Layout >
        <div className="container">
            <div className="article-container">
                <h1>
                    MQTT клиент
                </h1>
                <div className=" w-100 align-start  ">
                    <p >
                        Использование <b>MQTT (Message Queuing Telemetry Transport) клиента</b> в SCADA NPT Expert позволяет решать ряд важных задач, связанных с передачей данных, управлением устройствами и интеграцией различных компонентов системы. MQTT — это легкий и эффективный протокол обмена сообщениями, который широко используется в IoT (Интернете вещей) и промышленной автоматизации благодаря своей простоте, низкому потреблению ресурсов и поддержке работы в условиях нестабильных сетей.
                    </p>
                    <div style={{ float: 'right' }}>
                        <div style={{ maxWidth: '500px' }}>
                            <ZoomImageContainer
                                image={MQTTClient}
                            />
                            {/* <img
                                src={MQTTClient}
                                className="mb-4  w-100"
                                alt="MQTT Клиент"
                            /> */}
                        </div>
                    </div>
                    <div>
                        <p>Основные задачи, которые решает использование MQTT клиента в SCADA NPT Expert, включают:</p>

                        <ul className="mb-4 description__list">

                            <li className="mb-1 description__number-li"><b>Эффективная передача данных</b>
                                <ul>
                                    <li>MQTT обеспечивает передачу данных между устройствами (например, датчиками, контроллерами) и SCADA-системой в режиме реального времени.</li>
                                    <li>Данные передаются в формате "издатель-подписчик" (publish-subscribe), что позволяет минимизировать задержки и нагрузку на сеть.</li>
                                </ul>
                            </li>
                            <li className="mb-1 description__number-li"><b>Поддержка работы в условиях нестабильных сетей</b>
                                <ul>
                                    <li>MQTT разработан для работы в условиях низкой пропускной способности и нестабильных сетей (например, GSM, спутниковая связь).</li>
                                    <li>Протокол поддерживает механизмы повторной передачи сообщений и хранения данных на стороне брокера, что гарантирует доставку информации даже при временных разрывах связи.</li>
                                </ul>
                            </li>
                            <li className="mb-1 description__number-li"><b>Централизованное управление данными</b>
                                <ul>
                                    <li> MQTT-брокер выступает в качестве центрального узла, который управляет передачей сообщений между устройствами и SCADA-системой. Это упрощает управление данными и обеспечивает их согласованность.</li>
                                </ul>
                            </li>
                            <li className="mb-1 description__number-li"><b>Поддержка различных типов данных</b>
                                <ul>
                                    <li>MQTT позволяет передавать данные различных типов, включая:
                                        <ul>
                                            <li>Телеметрические данные (например, температура, давление, напряжение).</li>
                                            <li> Состояние оборудования (включено/выключено, аварийные сигналы).</li>
                                            <li>Команды управления (например, включение/выключение устройств).</li>
                                        </ul>

                                    </li>
                                </ul>
                            </li>
                            <li className="mb-1 description__number-li"><b>Интеграция с IoT-устройствами</b>
                                <ul>
                                    <li>MQTT широко используется в IoT, что позволяет SCADA легко интегрироваться с IoT-устройствами, такими как:
                                        <ul>
                                            <li>Умные датчики.</li>
                                            <li>Промышленные контроллеры.</li>
                                            <li>Устройства для мониторинга окружающей среды.</li>
                                        </ul>

                                    </li>
                                </ul>
                            </li>
                            <li className="mb-1 description__number-li"><b>Обеспечение безопасности</b>
                                <ul>
                                    <li>  MQTT поддерживает механизмы аутентификации и шифрования (например, TLS/SSL), что обеспечивает защиту данных от несанкционированного доступа. Это особенно важно для SCADA-систем, работающих в критически важных отраслях, таких как энергетика и промышленность.</li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                    <div style={{ clear: 'both' }}></div>

                </div>

            </div>
        </div>
    </Layout>
}
export const meta = {
    title: 'MQTT клиент',
    description: 'Использование MQTT (Message Queuing Telemetry Transport) клиента в SCADA NPT Expert позволяет решать ряд важных задач, связанных с передачей данных, управлением устройствами и интеграцией различных компонентов системы. MQTT — это легкий и эффективный протокол обмена сообщениями, который широко используется в IoT (Интернете вещей) и промышленной автоматизации благодаря своей простоте, низкому потреблению ресурсов и поддержке работы в условиях нестабильных сетей.'
}